import React from 'react';
import { UserSessionProvider } from 'src/context/UserSessionContext';
import { ParallaxProvider } from 'react-scroll-parallax';
import { ThemeProvider } from '@mui/material/styles';
import Layout from 'src/layout/Layout/Layout';
import muiTheme from 'src/themes/muiTheme';

const App: React.FC = () => {
  return (
    <>
      <ThemeProvider theme={muiTheme}>
        <ParallaxProvider>
          <UserSessionProvider>
            <Layout />
          </UserSessionProvider>
        </ParallaxProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
